import { Badge, Group, Title } from '@mantine/core'

import type { EscopoWhatsApi } from '@/hooks/useEscopoWhatsApi'

/**
 * Título das telas do WhatsApi com o escopo resolvido (spec 2026-11-02 §5.5):
 * "API Keys · JOINTER" com o selo "Organização", ou o nome do tenant com o selo
 * "Tenant" ("Tenant (legado)" em API Keys). O nome vem do escopo, nunca do menu:
 * é o que deixa visível quando os dois divergem.
 */
export function TituloDoEscopo({
  titulo, escopo, nome, seloTenant = 'Tenant', order = 3,
}: {
  titulo: string
  escopo: EscopoWhatsApi
  nome: string | null
  seloTenant?: string
  order?: 2 | 3
}) {
  const selo = escopo.tipo === 'organizacao' ? 'Organização' : escopo.tipo === 'tenant' ? seloTenant : null
  return (
    <Group gap="xs" align="center" wrap="nowrap">
      <Title order={order}>{nome && escopo.tipo !== 'nenhum' ? `${titulo} · ${nome}` : titulo}</Title>
      {selo && (
        <Badge variant="light" color={escopo.tipo === 'organizacao' ? 'blue' : 'gray'}>
          {selo}
        </Badge>
      )}
    </Group>
  )
}
